export const PREFIX = {
  identity: "Identity",
  productionPlan: "ProductionPlan",
  tracking: "BarCodeQRCode",
  masterData: "MasterDataConfiguration",
  receive: "Receive",
  report: "Report",
  printing: "Printing",
};
